import { useQuery } from "@tanstack/react-query";
import {
  IGetHrDataSearchParams,
  HrDataSearchService,
} from "../../../../services/vos/permission-lookup/hr-data-search.service";

const useHrDataSearch = (params?: IGetHrDataSearchParams) => {
  const query = useQuery({
    queryKey: ["hr-data-search", params?.module, params?.keySearch, params?.depID],
    queryFn: () => HrDataSearchService.getHrData(params!),
    enabled: !!params?.module && !!params?.keySearch && params.keySearch.length > 0,
  });

  return query;
};

export default useHrDataSearch;
